import { render, staticRenderFns } from "./ReservationAppPage.vue?vue&type=template&id=5ff8af16"
import script from "./ReservationAppPage.vue?vue&type=script&lang=js"
export * from "./ReservationAppPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports